import i18n from "../i18n";

type DateInput = Date | number | string | null | undefined;

// Timestamps arrive as epoch seconds (DynamoDB rows), epoch milliseconds
// (Date.now() callers) or ISO strings. Anything under 1e12 is seconds — that
// boundary is the year 2001 in milliseconds, so no real row is ambiguous.
export const toDate = (value: DateInput): Date | null => {
  if (value === null || value === undefined || value === "") return null;
  const d =
    typeof value === "number"
      ? new Date(value < 1e12 ? value * 1000 : value)
      : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

const viaKey =
  (key: string) =>
  (value: DateInput, fallback = "-") => {
    const date = toDate(value);
    return date ? i18n.t(key, { date }) : fallback;
  };

/** "09/16/2026 at 2:00 PM" — the one date+time format for every admin table. */
export const formatDateTime = viaKey("common.dateTime");
/** "09/16/2026 at 2:00:07 PM" — sensor report times, where a minute is too coarse. */
export const formatDateTimeSeconds = viaKey("common.dateTimeSeconds");
/** "09/16/2026" */
export const formatDate = viaKey("common.date");
/** "2:00 PM" */
export const formatTime = viaKey("common.time");
